/* LA FICHA · 28-jul-2026
 *
 * Tres trabajos, ninguno decorativo:
 *   1. Elegir talla → precio, medidas y botones se ponen al día.
 *   2. Elegir color → el selector de talla muestra solo las tallas de ese color.
 *   3. La barra fija de celular aparece al pasar el pliegue.
 *
 * 🔴 FAIL-VISIBLE EN TODO. La línea de medidas nace `hidden`, la barra nace
 * fuera de pantalla y los botones nacen deshabilitados con su texto explicando
 * qué falta. Si este archivo no carga, lo que queda es una ficha con la
 * información completa a la vista y sin controles muertos — que es un estado
 * perfectamente bueno. Nada de lo que hay aquí es un requisito para entender la
 * prenda; todo es para comprarla más rápido.
 *
 * 🔴 Y NADA DE ESTO INVENTA DATOS. Si una variante no trae medidas cargadas, se
 * muestra la raya, no un número plausible. En una tienda que NO acepta cambios
 * por talla, un centímetro inventado es una clienta enojada sin salida.
 */
(function () {
  var raiz = document.querySelector('[data-ficha]');
  if (!raiz) return;

  var tallas   = [].slice.call(raiz.querySelectorAll('[data-tallas] .f-talla'));
  var colores  = [].slice.call(raiz.querySelectorAll('.f-color'));
  var viva     = raiz.querySelector('[data-viva]');
  var idOculto = raiz.querySelector('[data-id-variante]');
  var precio   = raiz.querySelector('[data-precio]');
  var agregar  = raiz.querySelector('[data-agregar]');
  /* Los botones de WhatsApp del puente de venta (ficha + barra de celular).
     Si la casilla está apagada no existen y todo lo de abajo se salta. */
  var enlacesWa = [].slice.call(document.querySelectorAll('[data-wa]'));
  var textoAgr = raiz.querySelector('[data-texto-agregar]');
  var pago     = raiz.querySelector('[data-pago]');
  var cifra    = raiz.querySelector('[data-grande-cifra]');
  var cifraT   = raiz.querySelector('[data-grande-talla]');
  var parCint  = raiz.querySelector('[data-par-cintura]');
  var parLargo = raiz.querySelector('[data-par-largo]');
  var barra       = document.querySelector('[data-barra]');
  var barraBoton  = barra && barra.querySelector('[data-barra-boton]');
  var barraPrecio = barra && barra.querySelector('[data-barra-precio]');
  var barraMedida = barra && barra.querySelector('[data-barra-medida]');

  var elegida = null;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Si el navegador no trae Web Animations API, `anima()` devuelve null y cada
     quien sigue de largo con el estado final ya puesto. Nunca se espera a una
     animación que no existe. */
  var puedeAnimar = !quieto && typeof Element !== 'undefined' && !!Element.prototype.animate;

  /* 🔴 EL MOTOR DE MOVIMIENTO DE ESTA PÁGINA — Y POR QUÉ NO ES CSS.
     Cuatro intentos de animar en CSS dejaron contenido invisible (el porqué
     completo está en `avora-ficha.css`). Los cuatro compartían el mismo defecto:
     el estado final del contenido dependía de que la animación TERMINARA.

     Esto lo invierte. `fill` se queda en su valor por omisión —`none`—, así que
     la animación no deja ni un rastro: mientras corre se ve el movimiento, y
     apenas acaba, manda otra vez el CSS, que siempre describe el estado bueno.
     Si el reloj de animación está congelado, si el rAF va throttleado o si este
     archivo entero no carga, lo que queda a la vista es el contenido completo.

     Una animación aquí solo puede AÑADIR movimiento. No puede quitar contenido. */
  function anima(el, cuadros, ms, curva) {
    if (!puedeAnimar || !el) return null;
    try {
      return el.animate(cuadros, {
        duration: ms,
        easing: curva || 'cubic-bezier(0.19, 1, 0.22, 1)'   /* --ease del tema */
      });
    } catch (e) { return null; }
  }

  /* Sin talla no se compra, y el botón lo DICE en vez de fallar al pulsarlo.
     Cuatro de las doce fichas medidas hacen esto; en una tienda sin cambios
     vale doble, porque el error de talla no tiene vuelta atrás. */
  /* El mensaje de WhatsApp se rearma con la talla elegida. El precio se lee del
     botón de la talla —no del precio de la ficha— porque en una prenda con
     varias variantes cada talla puede costar distinto.

     Fail-visible: el `href` ya nace escrito desde el Liquid con prenda, precio y
     enlace. Si esto no corre, el mensaje sale sin la talla y se puede contestar
     igual; nunca queda un botón que no manda nada. */
  /* El anticipo del apartado viaja YA CALCULADO en el botón de la talla
     (`data-anticipo-variante`, hecho en Liquid). Aquí no se hace aritmética a
     propósito: el precio llega formateado como "$1,290.00" y volverlo número
     obliga a adivinar cuál signo separa miles y cuál decimales — eso cambia con
     el idioma de la tienda y se rompería sin avisar. */
  function pintaWhatsApp(b) {
    var talla     = b ? (b.textContent || '').trim() : '';
    var precio    = b ? (b.getAttribute('data-precio-variante') || '') : '';
    var anticipo  = b ? (b.getAttribute('data-anticipo-variante') || '') : '';

    /* Los dos números del renglón del apartado. Sólo se tocan si la talla trae
       el dato: si no, se queda el que pintó el servidor, que es correcto para
       la variante que estaba elegida. Nunca se deja el renglón en blanco. */
    if (anticipo) {
      [].forEach.call(document.querySelectorAll('[data-apartado-anticipo]'), function (n) {
        n.textContent = anticipo;
      });
    }
    if (precio) {
      [].forEach.call(document.querySelectorAll('[data-apartado-precio]'), function (n) {
        n.textContent = precio;
      });
    }

    if (!enlacesWa.length) return;
    enlacesWa.forEach(function (a) {
      var num    = a.getAttribute('data-wa-num');
      var prenda = a.getAttribute('data-wa-prenda');
      var url    = a.getAttribute('data-wa-url');
      if (!num) return;
      var msg = 'Hola, me interesa la ' + prenda;
      if (talla)  msg += ', talla ' + talla;
      if (precio) msg += ' (' + precio + ')';
      msg += '.';
      /* El anticipo entra al mensaje sólo si esta ficha lo ofrece — el atributo
         lo pone el Liquid nada más cuando el apartado está encendido. Así el
         mensaje nunca menciona un apartado que el sitio no está ofreciendo. */
      var apDelEnlace = a.getAttribute('data-wa-anticipo');
      if (apDelEnlace) msg += ' Quiero apartarla con ' + (anticipo || apDelEnlace) + '.';
      msg += ' ' + url;
      a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
    });
  }

  function estadoBotones() {
    var lista = elegida !== null;
    if (agregar) agregar.disabled = !lista;
    if (textoAgr) textoAgr.textContent = lista ? 'Agregar a la bolsa' : 'Elige tu talla';
    if (barraBoton) barraBoton.textContent = lista ? 'Agregar a la bolsa' : 'Elige tu talla';
    /* El botón de pago se apaga con el mismo criterio: un pago de un toque que
       se dispara sin talla es una venta que rebota en el checkout. */
    if (pago) {
      if (lista) pago.removeAttribute('data-sin-talla');
      else pago.setAttribute('data-sin-talla', '');
    }
  }

  /* ── EL ODÓMETRO DE LA CIFRA GIGANTE ──────────────────────────────────────
     Razón (test del porqué): ESTADO. Sin esto, 86 se vuelve 92 sin que el ojo
     registre que cambió justo el número que decide la compra. Y es el ÚNICO
     lugar del sitio con una escala absurda (`--t-medida`, hasta 176px): si algo
     merece el momento memorable de esta página, es este dígito.

     El dígito viejo se va HACIA ARRIBA y el nuevo entra DESDE ABAJO, como un
     odómetro: el valor nuevo empuja al viejo. Al revés se leería como deshacer.

     🔴 Y CAMBIA EL TEXTO PASE LO QUE PASE. El `setTimeout` no es un adorno: si
     el reloj de animación va congelado, `onfinish` no llega nunca y la cifra se
     quedaría en la talla anterior — mostrando una medida que NO corresponde a la
     talla elegida. En una tienda sin cambios, eso no es un bug de animación:
     es un número equivocado. Es idempotente: si `onfinish` sí llegó, no hace
     nada. */
  function rodar(el, nuevo) {
    if (el.textContent.trim() === nuevo) return;
    var poner = function () {
      if (el.textContent.trim() === nuevo) return;
      el.textContent = nuevo;
      anima(el, [{ opacity: 0, transform: 'translateY(45%)' },
                 { opacity: 1, transform: 'translateY(0)' }], 340);
    };
    var salida = anima(el, [{ opacity: 1, transform: 'translateY(0)' },
                            { opacity: 0, transform: 'translateY(-45%)' }],
                       180, 'cubic-bezier(0.85, 0, 0.15, 1)');
    if (!salida) { el.textContent = nuevo; return; }
    salida.onfinish = poner;
    setTimeout(poner, 240);
  }

  function pintarMedidas(b) {
    var busto   = b.getAttribute('data-busto');
    var cintura = b.getAttribute('data-cintura');
    var largo   = b.getAttribute('data-largo');
    var etiqueta = (b.textContent || '').trim();

    /* La cifra gigante y la tabla solo se tocan si el dato existe de verdad.
       El cambio de dígito se anuncia: sin eso, 86 se vuelve 92 sin que el ojo
       registre que cambió justo el número que decide la compra. */
    if (cifra) rodar(cifra, String(busto || '—'));
    /* Los tres números son EL RENGLÓN de la talla elegida (el formato de LV), así
       que los tres tienen que moverse juntos. Si solo rodara el busto, cintura y
       largo se quedarían mostrando la talla anterior — un número correcto al lado
       de dos equivocados es peor que no mostrar nada. */
    if (parCint)  rodar(parCint,  String(cintura || '—'));
    if (parLargo) rodar(parLargo, String(largo || '—'));
    if (cifraT) cifraT.textContent = etiqueta;

    /* La columna de la talla elegida se marca en la tabla transpuesta. Ahora se
       empata por el TEXTO de la talla y no por el id de variante: la tabla ya no
       tiene una fila por variante, tiene una columna por talla. */
    [].forEach.call(raiz.querySelectorAll('[data-col-talla]'), function (c) {
      if (c.getAttribute('data-col-talla') === etiqueta) c.setAttribute('data-elegida', '');
      else c.removeAttribute('data-elegida');
    });

    if (!viva) return;
    if (!busto && !cintura && !largo) {
      /* 🔴 YA NO SE ANUNCIA LA CARENCIA (30-ago-2026). Este renglón decía
         «faltan las medidas de esta prenda» y se veía en LAS 57 FICHAS —
         ninguna tiene medidas cargadas. Se escribió como un hueco honesto para
         nosotros, pero quien lo leía era la clienta, y lo que le decía era
         «esta tienda está a medias».

         Y ya no es un pendiente: Priscila trabaja con varios distribuidores y
         no hay una tabla de tallas común, así que la decisión tomada con ella
         es que NO va a haber medidas por prenda. Un hueco que nunca se va a
         llenar no es honestidad, es un defecto permanente a la vista.

         En su lugar el renglón se calla y la ficha ofrece preguntar, que es lo
         que ella resuelve de verdad por WhatsApp.

         ⚠️ Si algún día se cargan medidas, el código de abajo las pinta solo:
         esto sólo cubre el caso de que no las haya. */
      viva.hidden = true;
      return;
    }
    var partes = [];
    if (busto)   partes.push('busto ' + busto);
    if (cintura) partes.push('cintura ' + cintura);
    if (largo)   partes.push('largo ' + largo);
    viva.innerHTML = 'Talla <strong>' + etiqueta + '</strong> · ' + partes.join(' · ') + ' cm';
    viva.hidden = false;
  }

  /* La etiqueta hablada del botón de talla se reescribe junto con `aria-pressed`.
     Se renderiza desde Liquid con el estado ("Talla M — disponible, elegida"),
     pero al cambiar de talla o de color ese texto se quedaba con el estado del
     primer pintado: quien usa lector de pantalla seguía oyendo "elegida" en la
     talla vieja. El atributo visible y el hablado tienen que moverse juntos. */
  function rotular(b) {
    var t = (b.textContent || '').trim();
    var estado = b.disabled ? ' — agotada'
               : (b === elegida ? ' — disponible, elegida' : ' — disponible');
    b.setAttribute('aria-label', 'Talla ' + t + estado);
  }

  function elegir(b) {
    if (b.disabled) return;
    elegida = b;
    tallas.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); rotular(o); });
    if (idOculto) idOculto.value = b.getAttribute('data-variante');
    pintaWhatsApp(b);

    var pv = b.getAttribute('data-precio-variante');
    if (pv && precio) precio.firstChild.nodeValue = pv + ' ';
    if (pv && barraPrecio) barraPrecio.textContent = pv;

    /* La medida viaja con ella hasta el pie de la página. Si la prenda no trae
       busto cargado, el renglón se queda vacío y el CSS lo esconde — antes que
       escribir "—" en una barra de compra, que se lee como un error. */
    if (barraMedida) {
      var bustoBarra = b.getAttribute('data-busto');
      barraMedida.textContent = bustoBarra
        ? 'Talla ' + (b.textContent || '').trim() + ' · busto ' + bustoBarra + ' cm'
        : '';
    }

    pintarMedidas(b);
    estadoBotones();
  }

  tallas.forEach(function (b) {
    b.addEventListener('click', function () { elegir(b); });
  });

  /* ── EL COLOR FILTRA LAS TALLAS ─────────────────────────────────────────
     Sin esto, una prenda en dos colores mostraría la talla M dos veces y al
     pulsar una podría añadirse el color equivocado. */
  function filtrarPorColor(valor) {
    var quedaElegida = false;
    tallas.forEach(function (b) {
      var suyo = b.getAttribute('data-color-de') || '';
      var visible = !valor || !suyo || suyo === valor;
      b.hidden = !visible;
      if (visible && b === elegida) quedaElegida = true;
    });
    /* Si la talla elegida no existe en el color nuevo, se suelta la selección
       en vez de dejar un botón marcado que ya no corresponde. */
    if (elegida && !quedaElegida) {
      var suelta = elegida;
      elegida = null;
      suelta.setAttribute('aria-pressed', 'false');
      rotular(suelta);
      if (viva) viva.hidden = true;
      /* 🔴 Y LA MEDIDA DE LA BARRA SE VA CON ELLA. Verificado en pantalla el
         28-jul: al cambiar de color, la barra decía "Elige tu talla" y debajo
         seguía "Talla G · busto 98 cm" — una medida que ya no correspondía a
         nada seleccionado. En una tienda sin cambios por talla, un número
         huérfano en la barra de compra es exactamente el dato que no puede
         quedar mintiendo. */
      if (barraMedida) barraMedida.textContent = '';
      estadoBotones();
    }
  }

  /* ── Y EL COLOR LLEVA A SU FOTO ─────────────────────────────────────────
     Hueco real, no adorno: hoy elegir "Blanco" no cambia nada en pantalla, así
     que la clienta elige a ciegas el dato más visible de la prenda. La galería
     está apilada (escritorio) o en carrusel (celular), así que "cambiar la foto"
     aquí significa LLEVARLA a la foto de ese color.

     Se empata por URL de archivo, no por id — ver el porqué en el Liquid. Si el
     producto no trae foto por variante, `data-src` no existe y esto no hace
     nada: no se inventa un salto a una foto cualquiera. */
  var galeria = raiz.querySelector('[data-galeria]');

  /* 🔴 SI ELIGE AZUL, LAS BLANCAS NO SALEN. No es llevar la galería a una foto:
     es esconder las de los otros colores. Cada foto trae `data-color-de`, que
     el Liquid saca del texto alternativo (Liquid no expone la lista de fotos por
     variante, sólo una).

     Una foto SIN etiqueta se muestra siempre: no se sabe de qué color es, y
     esconder a ciegas borraría una prenda de la vista sin que nadie se entere.
     Fail-visible: si esto no corre, se ven todas, que es como estaba antes. */
  function filtraFotosPorColor(color) {
    if (!galeria) return;
    var fotos = [].slice.call(galeria.querySelectorAll('.f-galeria__foto'));
    var etiquetadas = fotos.filter(function (f) { return f.getAttribute('data-color-de'); });
    if (!etiquetadas.length) return;          /* prenda de un solo color: no se toca */
    fotos.forEach(function (f) {
      var c = f.getAttribute('data-color-de') || '';
      if (!c || !color || c === color) f.removeAttribute('data-fuera');
      else f.setAttribute('data-fuera', '');
    });
  }

  function irAFotoDe(c) {
    if (!galeria) return;
    var src = c.getAttribute('data-src');
    if (!src) return;
    var foto = [].slice.call(galeria.querySelectorAll('[data-src]')).filter(function (f) {
      return f.getAttribute('data-src') === src;
    })[0];
    if (!foto) return;
    var enCarrusel = galeria.scrollWidth > galeria.clientWidth + 4;
    if (enCarrusel) {
      /* Dentro del carrusel se recorre el CARRUSEL, no la página: un
         `scrollIntoView` normal aquí arrastraría toda la ficha hacia arriba. */
      galeria.scrollTo({ left: foto.offsetLeft - galeria.offsetLeft, behavior: 'smooth' });
    } else {
      foto.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  colores.forEach(function (c) {
    c.addEventListener('click', function () {
      colores.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      filtrarPorColor(c.getAttribute('data-color'));
      filtraFotosPorColor(c.getAttribute('data-color'));
      irAFotoDe(c);
    });
  });

  var colorInicial = colores.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0];
  if (colorInicial) {
    filtrarPorColor(colorInicial.getAttribute('data-color'));
    filtraFotosPorColor(colorInicial.getAttribute('data-color'));
  }

  /* Al cargar, si Shopify ya trae una variante seleccionada y disponible, se
     respeta. Si no, NO se elige una por la clienta: que elija ella. */
  var yaMarcada = tallas.filter(function (b) {
    return b.getAttribute('aria-pressed') === 'true' && !b.disabled && !b.hidden;
  })[0];
  if (yaMarcada && tallas.length === 1) elegir(yaMarcada);
  else {
    tallas.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); rotular(b); });
    estadoBotones();
  }

  /* ── LA BARRA FIJA DE CELULAR ───────────────────────────────────────────
     4 de 7 fichas medidas la tienen. Con tráfico casi todo iPhone es la
     diferencia entre volver a subir para comprar y comprar.
     Si todavía no hay talla, el botón no intenta añadir nada: lleva al
     selector y lo deja enfocado. Un botón que falla enseña menos que uno que
     te lleva a lo que falta. */
  if (barra && agregar) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) barra.removeAttribute('data-visible');
          else barra.setAttribute('data-visible', '');
        });
      }, { rootMargin: '0px 0px -100% 0px' }).observe(agregar);
    }

    /* 🔴 `barraBoton` PUEDE NO EXISTIR. Cuando se aparta por WhatsApp, la barra
       fija pinta un `<a>` a wa.me en vez del botón de talla: ahí no hay
       `[data-barra-boton]` que escuchar. La guarda de arriba mira `agregar`, que
       SÍ existe en ese modo —es «Agregar a la bolsa»—, así que el bloque entra y
       sin esta línea reventaba con «Cannot read properties of null», y el
       TypeError se llevaba por delante todo lo que va después en este archivo:
       los íconos de cuidado, el zoom de la galería y los plegados. */
    if (barraBoton) barraBoton.addEventListener('click', function () {
      if (elegida) { agregar.click(); return; }
      var lista = raiz.querySelector('[data-tallas]');
      if (!lista) return;
      lista.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var primera = tallas.filter(function (b) { return !b.disabled && !b.hidden; })[0];
      if (primera) primera.focus({ preventScroll: true });
    });
  }

  /* ── LOS ÍCONOS DE CUIDADO SE TRAZAN AL ABRIR ───────────────────────────
     Mismo motor que las cotas de la medida: la longitud real de cada trazo con
     `getTotalLength()`, nunca un número inventado.

     🔴 SE HACE AL ABRIR, NO AL CARGAR. Dentro de un `<details>` cerrado el SVG
     no tiene layout y `getTotalLength()` devuelve 0 — por eso el motor global
     `medida()` de `avora-motion.js` no puede encargarse de estos: cuando corre,
     el acordeón todavía está cerrado.

     Fail-visible: si algo falla, el `dashoffset` se queda en 0 y los íconos se
     ven enteros. Nunca desaparecen. */
  function trazarAlAbrir(caja) {
    var trazos = [].slice.call(caja.querySelectorAll('.f-cuidado .c-trazo, .f-silueta .c-cota'));
    if (!trazos.length) return;
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    trazos.forEach(function (t) {
      var largo;
      try { largo = t.getTotalLength(); } catch (e) { return; }
      if (!largo) return;
      t.style.strokeDasharray = largo;
      if (quieto) { t.style.strokeDashoffset = 0; return; }
      t.style.strokeDashoffset = largo;
      /* Dos cuadros de margen: si se pinta en el mismo, el navegador junta el
         estado inicial y el final y no hay transición que ver.

         🔴 Y UNA RED DE SEGURIDAD CON `setTimeout`. Verificado en pantalla el
         28-jul: con SOLO los `requestAnimationFrame` los cinco íconos quedaron
         invisibles —`dashoffset` clavado en su longitud completa—. El preview
         de Shopify throttlea rAF cuando la pestaña no está al frente, así que
         el cuadro que devuelve el trazo nunca llega. Sin esta red, la
         animación ESCONDE el contenido, que es exactamente lo que no puede
         pasar: es el mismo fallo que ya había dejado media galería en blanco.
         El timeout es idempotente — si rAF sí corrió, esto no cambia nada. */
      var arranca = function () { t.style.strokeDashoffset = 0; };
      requestAnimationFrame(function () { requestAnimationFrame(arranca); });
      setTimeout(arranca, 120);
    });
  }

  /* ── EL ACORDEÓN QUE ABRE SUAVE ─────────────────────────────────────────
     Cuatro versiones en CSS fallaron y las cuatro escondieron contenido. El
     porqué largo está en `avora-ficha.css`; el resumen es que todas dejaban el
     estado final en manos de la animación.

     Aquí no. El CSS deja la envoltura en su estado natural —altura automática,
     sin recorte— y este código:
       1. mide cuánto ocupa el contenido YA abierto (nunca una altura inventada),
       2. anima de 0 a esa altura con `fill` por omisión (= `none`),
       3. pone `overflow: hidden` SOLO mientras dura, y lo quita al terminar.

     Al no haber `fill`, en cuanto la animación acaba —o si nunca corre— el
     elemento vuelve a lo que dice el CSS: abierto y completo. Y el `overflow`
     temporal es lo que evita el otro fallo ya cazado, cuando un `overflow:
     hidden` permanente recortó 78px en silencio.

     El cierre necesita retener el `<details>`: si se deja cerrar solo, el
     contenido desaparece antes del primer cuadro. Por eso se cancela el evento,
     se anima, y se cierra al terminar — con `setTimeout` de respaldo, porque un
     acordeón que no cierra por culpa de un reloj congelado sería peor que uno
     que cierra de golpe. */
  function animarApertura(env) {
    var alto = env.scrollHeight;
    if (!alto) return;
    var a = anima(env, [{ height: '0px', opacity: 0 },
                        { height: alto + 'px', opacity: 1 }], 420);
    if (!a) return;
    env.style.overflow = 'hidden';
    var limpiar = function () { env.style.overflow = ''; };
    a.onfinish = limpiar;
    a.oncancel = limpiar;
    setTimeout(limpiar, 700);   /* red: el overflow jamás se queda puesto */

    /* El contenido entra un pelo después que la caja: primero se abre el hueco,
       luego aparece lo que trae. Simultáneo se lee como un salto. */
    var c = env.firstElementChild;
    if (c) anima(c, [{ opacity: 0, transform: 'translateY(10px)' },
                     { opacity: 0, transform: 'translateY(10px)', offset: 0.25 },
                     { opacity: 1, transform: 'translateY(0)' }], 560);
  }

  [].forEach.call(raiz.querySelectorAll('.f-plegado'), function (d) {
    var env = d.querySelector('.f-plegado__envoltura');
    var cerrando = false;

    d.addEventListener('toggle', function () {
      if (!d.open) return;
      trazarAlAbrir(d);
      if (env) animarApertura(env);
    });

    var t = d.querySelector('.f-plegado__t');
    if (t && env) {
      t.addEventListener('click', function (e) {
        if (!d.open || cerrando || !puedeAnimar) return;   /* abrir lo maneja el navegador */
        e.preventDefault();
        cerrando = true;
        var alto = env.scrollHeight;
        var a = anima(env, [{ height: alto + 'px', opacity: 1 },
                            { height: '0px', opacity: 0 }], 300);
        var cerrar = function () {
          env.style.overflow = '';
          d.open = false;
          cerrando = false;
        };
        if (!a) { cerrar(); return; }
        env.style.overflow = 'hidden';
        a.onfinish = cerrar;
        setTimeout(cerrar, 500);   /* red: nunca se queda abierto a la fuerza */
      });
    }
  });

  /* 🔴 AQUÍ VIVÍA EL RESALTADO DE COTA — se fue con la silueta el 28-jul.
     Encendía la línea del busto sobre el dibujo al señalar esa columna de la
     tabla. Se quitó junto con la silueta (cero de seis casas ponen un dibujo),
     y con él se va el único bug que quedaba abierto de la sesión: las otras dos
     cotas no bajaban a `opacity: .25` y no llegué a entender por qué.
     Que desaparezca porque desapareció la función no es haberlo resuelto — es
     que ya no hay nada que resolver. Si la silueta vuelve, el bug vuelve con
     ella y hay que mirarlo en frío. */

  /* ── LA GUÍA DE TALLAS ──────────────────────────────────────────────────
     No abre un modal propio: despliega el acordeón de medidas, que es donde ya
     vive el dato. Una tabla de tallas genérica al lado de las medidas reales de
     la prenda sería decirle dos cosas distintas a la misma clienta. */
  var guia = raiz.querySelector('[data-guia]');
  var plegadoMedidas = raiz.querySelector('[data-plegado="medidas"]');
  if (guia && plegadoMedidas) {
    guia.addEventListener('click', function () {
      plegadoMedidas.open = true;
      plegadoMedidas.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ── LA LUPA DE TELA ────────────────────────────────────────────────────
     Razón (test del porqué): EXPLICACIÓN. Es la fricción número uno de comprar
     ropa sin tocarla, y ella vende "más fina y elegante" — el tejido ES el
     argumento. Las fotos ya se sirven a 1400px: el detalle está ahí, solo que
     hoy nadie puede verlo.

     Solo con puntero fino: en un dedo no hay cursor que seguir y ahí manda el
     carrusel. Se marca `data-lupa` desde el JS y no en el marcado, para que sin
     este archivo el cursor no prometa un zoom que no va a pasar. */
  if (galeria && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    [].forEach.call(galeria.querySelectorAll('.f-galeria__foto'), function (foto) {
      var img = foto.querySelector('img');
      if (!img) return;                    /* los huecos rotulados no se amplían */
      foto.setAttribute('data-lupa', '');
      foto.addEventListener('pointerenter', function () { foto.setAttribute('data-zoom', ''); });
      foto.addEventListener('pointerleave', function () {
        foto.removeAttribute('data-zoom');
        img.style.transformOrigin = '';
      });
      foto.addEventListener('pointermove', function (e) {
        var r = foto.getBoundingClientRect();
        /* El origen sigue al cursor: así se amplía LO QUE ESTÁ MIRANDO, no el
           centro de la foto. Sin esto el zoom es un truco; con esto es una lupa. */
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' +
          ((e.clientY - r.top) / r.height * 100) + '%';
      });
    });
  }

  /* ── LA HAIRLINE DE PROGRESO DEL CARRUSEL ───────────────────────────────
     Razón (test del porqué): ORIENTACIÓN. Sustituye a los puntitos —lenguaje de
     app, no de boutique— y dice dos cosas que los puntitos no: cuánto llevas y
     cuánto falta. Es 1px, el mismo grosor que todas las líneas del sitio.

     Nace llena desde el CSS. Si este bloque no corre, queda un separador
     honesto; nunca una barra vacía que parece rota. */
  var progreso = document.querySelector('[data-progreso] span');
  if (galeria && progreso) {
    var pintarProgreso = function () {
      var recorrible = galeria.scrollWidth - galeria.clientWidth;
      if (recorrible <= 4) { progreso.style.scale = ''; return; }  /* no hay carrusel */
      var visible = galeria.clientWidth / galeria.scrollWidth;
      var avance  = galeria.scrollLeft / recorrible;
      /* `translate` se aplica ANTES que `scale` y en unidades sin transformar,
         así que el % es sobre el ancho COMPLETO de la línea: el trozo visible
         recorre exactamente el hueco que le deja su propio tamaño. */
      progreso.style.scale = visible + ' 1';
      progreso.style.translate = (avance * (1 - visible) * 100) + '% 0';
    };
    galeria.addEventListener('scroll', pintarProgreso, { passive: true });
    window.addEventListener('resize', pintarProgreso);
    pintarProgreso();
  }

  /* ══ CONFIRMACIÓN AL AGREGAR, SIN SALIR DE LA FICHA ══════════════════════
     Del scout del 28-jul (`_scout/QOL-LUJO.md`): al agregar, Gucci abre un
     panel "ADDED TO SHOPPING BAG" con la prenda y DOS salidas —`CHECKOUT` y
     `VIEW SHOPPING BAG`— sin moverte de la página. Aquí el formulario hacía
     POST y te sacaba a /cart: perdías la ficha, el color elegido y el lugar
     del scroll, y si querías otra talla había que volver y buscar todo otra vez.

     🔴 FAIL-VISIBLE, y aquí importa más que en ningún otro lado: si este
     bloque no corre, NO se toca el formulario y el POST de siempre sigue
     llevando a /cart. Nunca queda un botón que no agrega nada. Por eso se
     intercepta el `submit` en vez de reemplazar el botón, y por eso el
     `preventDefault` está DENTRO del `try`. */
  (function () {
    if (typeof fetch !== 'function') return;
    var forma = raiz.querySelector('form[action*="/cart/add"]');
    if (!forma || !agregar) return;

    var panel = raiz.querySelector('[data-confirma]');
    if (!panel) return;

    var cerrar  = panel.querySelector('[data-confirma-cerrar]');
    var nombre  = panel.querySelector('[data-confirma-nombre]');
    var detalle = panel.querySelector('[data-confirma-detalle]');
    var foco;

    function abrir() {
      foco = document.activeElement;
      panel.hidden = false;
      /* El foco entra al panel: si se queda en el botón de atrás, quien navega
         con teclado no se entera de que apareció nada. */
      if (cerrar) cerrar.focus();
      document.addEventListener('keydown', escapar);
    }
    function ocultar() {
      panel.hidden = true;
      document.removeEventListener('keydown', escapar);
      if (foco && foco.focus) foco.focus();
    }
    function escapar(e) { if (e.key === 'Escape') ocultar(); }
    if (cerrar) cerrar.addEventListener('click', ocultar);

    forma.addEventListener('submit', function (e) {
      /* Sin talla elegida no se manda nada: el botón ya dice "Elige tu talla"
         y `estadoBotones` lo tiene deshabilitado. Doble llave, por si acaso. */
      if (!elegida) return;
      e.preventDefault();

      agregar.setAttribute('data-cargando', '');
      agregar.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(forma) })
        .then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          return r.json();
        })
        .then(function (linea) {
          /* 🔴 AVISAR QUE LA BOLSA CAMBIÓ. Hasta hoy esto no salía de aquí: la
             ficha se conformaba con corregir el contador del encabezado a mano
             (justo abajo), y todo lo demás que depende de la bolsa se quedaba
             con lo de antes — el cajón pintaba la bolsa vieja al abrirse, y el
             botón de «Apartar por WhatsApp» mandaba un mensaje SIN la prenda
             que se acababa de agregar. Verificado en vivo el 28-ago: la bolsa
             tenía 1 pieza y el mensaje seguía enumerando las 2 anteriores.
             `avora:bolsa` es el aviso que ya usaba la vista rápida; el cajón
             sólo relee, no se abre solo. */
          document.dispatchEvent(new CustomEvent('avora:bolsa'));
          if (nombre)  nombre.textContent = linea.product_title || '';
          if (detalle) {
            var d = [];
            if (linea.variant_title && linea.variant_title !== 'Default Title') d.push(linea.variant_title);
            /* 🔴 NO se usa `linea.quantity`. `/cart/add.js` devuelve el total de
               ESA LÍNEA en la bolsa, no lo que se acaba de agregar: con dos
               piezas ya dentro, agregar una decía "3 piezas". Verificado en
               pantalla el 28-jul. Lo que se acaba de agregar lo sabe el
               formulario, y nadie más. */
            var campo = forma.querySelector('[name="quantity"]');
            var cuantas = campo ? parseInt(campo.value, 10) : 1;
            if (cuantas > 1) d.push(cuantas + ' piezas');
            detalle.textContent = d.join(' · ');
          }
          /* El contador del encabezado se mueve aquí también: si no, la clienta
             ve "agregado" y arriba sigue diciendo Bolsa (0). */
          var enlaces = document.querySelectorAll('a[href$="/cart"]');
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            Array.prototype.forEach.call(enlaces, function (a) {
              if (/Bolsa\s*\(\d+\)/.test(a.textContent)) {
                a.textContent = 'Bolsa (' + c.item_count + ')';
                a.setAttribute('aria-label', 'Bolsa, ' + c.item_count +
                  (c.item_count === 1 ? ' prenda' : ' prendas'));
              }
            });
          }).catch(function () {});

          /* 🔴 SE ABRE LA BOLSA. Es la respuesta a «no te avisa de nada»
             (30-ago-2026, tercera vuelta sobre lo mismo).

             Antes: un recuadro discreto bajo el botón. Se movió arriba del todo
             para que no lo tapara la barra, y aun así seguía sin leerse como
             «lo agregaste». El problema no era dónde estaba el aviso: era que
             un aviso NUNCA va a demostrar tanto como enseñar la bolsa con la
             prenda dentro.

             Es lo que hacen Everlane, Aesop, Sézane y el propio tema base de
             Shopify: al agregar, el cajón entra y ahí está la prenda, el total
             y el paso siguiente. No hay nada que interpretar.

             Y aquí encaja mejor que en ninguna tienda: el modelo de AVORA es
             «junta varias y las apartas en un solo mensaje», así que ver la
             bolsa acumulada después de cada prenda no interrumpe la compra —
             la explica.

             El aviso de antes queda como respaldo: si el cajón no estuviera en
             la página, la clienta sigue teniendo su confirmación. */
          var disparoBolsa = document.querySelector('[data-abre-cajon]');
          var hayCajon = document.querySelector('[data-cajon]');
          if (disparoBolsa && hayCajon) disparoBolsa.click();
          else abrir();
        })
        .catch(function () {
          /* Si el fetch falla, se manda el formulario de verdad. La clienta
             termina en /cart —el camino de siempre— en vez de quedarse con un
             botón que no hizo nada. */
          forma.submit();
        })
        .then(function () {
          agregar.removeAttribute('data-cargando');
          agregar.disabled = false;
          estadoBotones();
        });
    });
  })();
})();
